import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentMultiAccountTransferData,
  type EnrollmentMultiAccountTransferSubmitOutput,
} from '../../../../models'

export const getEnrollmentMultiAccountTransferDataMock: EnrollmentMultiAccountTransferData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/funding/account-transfer',
  enrollmentData: {
    applicationId: '1234567890',
  },
}

export const submitEnrollmentMultiAccountTransferDataMock: EnrollmentMultiAccountTransferSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/funding/account-transfer-success',
}

export const mockGetEnrollmentMultiAccountTransferData = graphql.mutation(
  'getEnrollmentMultiAccountTransferData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiAccountTransferDataMock } })
  },
)

export const mockSubmitEnrollmentMultiAccountTransferData = graphql.mutation(
  'submitEnrollmentMultiAccountTransferData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiAccountTransferDataMock } })
  },
)

export const mockEnrollmentMultiAccountTransfer = [
  mockGetEnrollmentMultiAccountTransferData,
  mockSubmitEnrollmentMultiAccountTransferData,
]
